module.exports = __webpack_public_path__ + "img/swimmingCoach.939d9b75.jpg";